<template>
  <div class="viewcontent" v-if="translations.buttons && translations.contact">
    <form class="row mx-3" @submit.prevent="prepareSendEmail()">
      <Alert type="warning" :list="errors.email"/>

      <label for="full_name" class="form-label w-100 my-3">
        {{ translations.contact.subject }}
        <span class="text-danger">*</span>
        <input
          type="text"
          id="full_name"
          name="full_name"
          :placeholder="translations.placeholders.contact_subject"
          class="form-control"
          v-model="contact.subject"
          required
        />
      </label>
      <label for="description" class="form-label w-100 my-3">
        {{ translations.contact.message }}
        <span class="text-danger">*</span>

        <textarea
          rows="5"
          class="form-control"
          id="description"
          name="description"
          :placeholder="translations.placeholders.contact_message"
          v-model="contact.message"
          required
        >
        </textarea>
      </label>
      <button class="btn btn-primary  w-100" type="submit">
        {{ translations.buttons.btn_contact }}
      </button>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  export default {
    name: 'Contact',
    components: {
      Alert,
    },
    data() {
      return {
        contact: {
          name: '',
          email: '',
          subject: '',
          message: '',
          tous: true,
        },
      }
    },
    computed: {
      ...mapState(['translations', 'user', 'errors']),
    },
    methods: {
      ...mapActions(['getUser', 'sendContactEmail', 'resetError']),
      prepareSendEmail() {
        this.sendContactEmail(this.contact)
      },
      setUser() {
        this.contact.name = this.user.full_name
        this.contact.email = this.user.email
      },
    },
    async created() {
      await this.getUser()
      await this.setUser()
    },
    beforeUnmount() {
      this.resetError()
    },
  }
</script>

<style></style>
